/**
 * Creates a temporary anchor to download a blob as a file.
 * @param blob The Blob data to download.
 * @param filename The desired filename, including extension.
 */
export default function downloadBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}